import "./icons.scss";

interface BaseIconProps {
    className?: string
}

const Close = (props: BaseIconProps) => {
    return (
        <svg {...props} className={`jss1 ${props?.className || ""}`} focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
            <path fill="none" d="M0 0h24v24H0z"></path>
        </svg>
    );
};

interface HrbLogoProps {
    width?: string,
    height?: string,
    heighthandleClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void
}

const HrbLogo = (props: HrbLogoProps) => {
    const { width = "", height = "", heighthandleClick = () => { } } = props
    return (
        <svg role="svg" style={{ cursor: "pointer" }} width={width} height={height} onClick={heighthandleClick} viewBox="0 0 792 288">
            <g>
                <rect x="94.3" y="89.5" style={{ fill: "#14aa40" }} width="107.2" height="107.2" />
            </g>
            <g>
                <path
                    d="M310.1,158.8c-3.7,0-8.8-2.1-8.8-7.1c0-2.9,1.9-5.1,3.7-6.3c0,0,8.8,9.9,10.7,11.9C314.8,158,312.5,158.8,310.1,158.8
                        M330.9,157.4c1.9-3.3,2.1-7.3,2.1-10.4v-8.4h-12v7.9l-12.6-14c-1.2-1.5-2-2.7-2-4.4c0-2.1,1.5-3.5,3.8-3.5c2.5,0,3.8,1.5,3.8,3.7
                        v2.6h12.9v-3.4c0-8.6-7.1-13.8-17-13.8c-10.7,0-17.6,5.6-17.6,14.1c0,2.4,0.8,6.1,4.4,9.4c-4.8,2.2-9.8,7.1-9.8,14.8
                        c0,10.7,8.4,17.9,23.3,17.9c5.1,0,9.9-1.4,13.3-3.7l2.4,2.6h15.1L330.9,157.4z"
                />
                <path
                    d="M370.3,141.3c4,0,6.2-2.7,6.2-6.4c0-4-2.1-6.5-6.2-6.5h-8.2v13H370.3z M367,154.6h-4.9v14.2h-16.9v-54.1h27
                        c13.8,0,21.2,8.2,21.2,20c0,7.7-3.5,13.7-9.3,17l10.7,17.1h-19.7L367,154.6z"
                />
                <polygon
                    points="231.6,114.8 248.5,114.8 248.5,134 262.4,134 262.4,114.8 279.3,114.8 279.3,168.8 262.4,168.8 262.4,149.4 
                        248.5,149.4 248.5,168.8 231.6,168.8 	"
                />
                <path
                    d="M448.8,156.4c2.7,0,4.2-2,4.2-4.6c0-2.4-1.7-4.5-4.3-4.5h-11.2v9.1H448.8z M445.5,135.9c2.7,0,4.1-1.9,4.1-4.5
                        c0-2.3-1.6-4.2-4.1-4.2h-7.8v8.7H445.5z M421.5,114.8h28c10.1,0,16.1,5.9,16.1,14c0,5.5-2.6,10-7.1,12.1
                        c6.5,1.5,10.4,5.9,10.4,12.6c0,9.1-6.6,15.4-19,15.4h-28.4V114.8z"
                />
                <polygon points="475.9,114.8 492.8,114.8 492.8,154.8 514.8,154.8 514.8,168.8 475.9,168.8 	" />
                <path
                    d="M553.9,146.2v-8.8c0-6.3-3.2-9.7-8.9-9.7c-5.7,0-8.9,3.4-8.9,9.7v8.8c0,6.2,3.2,9.7,8.9,9.7
                        C550.7,155.9,553.9,152.5,553.9,146.2 M519.2,145.2v-6.8c0-14.7,8.9-24.7,25.8-24.7c16.9,0,25.8,10.1,25.8,24.7v6.8
                        c0,14.7-8.9,24.7-25.8,24.7C528.1,169.9,519.2,159.9,519.2,145.2"
                />
                <path
                    d="M602.1,155.9c5.9,0,8.1-4.1,8.4-8h16c-0.4,12.2-8.9,22.1-24.1,22.1c-17.5,0-25.8-9.9-25.8-24.6v-7.1
                        c0-14.7,8.3-24.6,25.8-24.6c15.2,0,23.7,9.9,24.1,22.1h-16c-0.3-4-2.5-8-8.4-8c-5.8,0-8.6,3.8-8.6,9.7v8.6
                        C593.6,152.1,596.3,155.9,602.1,155.9"
                />
                <polygon
                    points="635.8,114.8 652.7,114.8 652.7,133.6 653.8,133.6 664.7,114.8 683.7,114.8 669.5,139.1 685.3,168.8 665.2,168.8 
                        654,146.3 652.7,146.3 652.7,168.8 635.8,168.8 	"
                />
                <path
                    d="M691.5,117.8c0.3,0,0.5-0.2,0.5-0.4c0-0.2-0.2-0.4-0.5-0.4h-0.4v0.8H691.5z M691.4,118.7h-0.3v1H690V116h1.7
                        c1,0,1.5,0.5,1.5,1.4c0,0.5-0.2,0.9-0.6,1.1l0.7,1.3H692L691.4,118.7z M695,118c0-2-1.3-3.5-3.5-3.5c-2.2,0-3.5,1.5-3.5,3.5
                        c0,2,1.3,3.5,3.5,3.5C693.7,121.6,695,120,695,118 M687,118c0-2.4,1.7-4.4,4.5-4.4c2.8,0,4.5,2,4.5,4.4c0,2.4-1.7,4.3-4.5,4.3
                        C688.7,122.4,687,120.4,687,118"
                />
            </g>
        </svg>
    );
};

export {
    Close,
    HrbLogo
};
